export { WrappedApp as StudioFoundationsApp } from './WrappedApp';
